module.exports = __webpack_public_path__ + "Cosmos_Cosplay.jpg?44e07105371260675c3a3e204adc78bd";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/Cosmos_Cosplay.jpg
// module id = 453
// module chunks = 0